import './Filters.scss';
import {
  FormControl,
  InputLabel,
  TextField,
  Typography,
  NativeSelect,
  InputAdornment,
  Input,
  IconButton,
  Button,
} from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { resetFilters, updateStateFilters, selectFilters } from '../../store/filtersSlice';
import { getOperators, getSubOperators } from '../../services/filtersService';
import { ru } from 'date-fns/locale';
import { checkAuth, decodeToken } from '../../services/autorization';


export const Filters = () => {
  const filters = useAppSelector(selectFilters);
  const {
    operatorList,
    operatorSubList,
    firstDate,
    lastDate,
    typeSearch,
    questionStatus,
    source,
    term,
    priority,
    operator_id,
    operator_sub_id,
    quesTheme,
  } = filters;

  const { role } = useAppSelector((state) => state.user);
  const typeQuestion = useAppSelector((state) => state.modal.type);
  const dispatch = useAppDispatch();
  const inpSearchRef = useRef<HTMLInputElement>(null);
  const [userId, setUserId] = useState<string>(''); 


  const handleChange = (key: keyof typeof filters, value: string) => {
    if (role !== '3') {
      if (key !== `operatorList`) {
        dispatch(updateStateFilters({ key, value }));
      }
    } else {
      if (key !== `operatorSubList`) {
        dispatch(updateStateFilters({ key, value }));
      }
    };
  }


  const onReset = () => {
     // dispatch(resetFilters());                         // Сбрасываем все фильтры
    dispatch(updateStateFilters({ key: 'priority', value: '0' }));
    dispatch(updateStateFilters({ key: 'questionStatus', value: '0' }));
    dispatch(updateStateFilters({ key: 'firstDate', value: '' }));
    dispatch(updateStateFilters({ key: 'lastDate', value: dayjs().format('YYYY.MM.DD') }));
    dispatch(updateStateFilters({ key: 'typeSearch', value: '0' }));
    dispatch(updateStateFilters({ key: 'searchQuery', value: '' }));
    dispatch(updateStateFilters({ key: 'term', value: '0' }));
    dispatch(updateStateFilters({ key: 'source', value: '0' }));
    dispatch(updateStateFilters({ key: 'quesTheme', value: '0' }));
    
    // Сброс значения фильтра по исполнителю, но не сбрасываем сам список операторов
    dispatch(updateStateFilters({ key: 'operator_id', value: '0' })); 
    dispatch(updateStateFilters({ key: 'operator_sub_id', value: '0' })); 
    
    if (inpSearchRef.current) {         
        inpSearchRef.current.value = '';   // Очищаем поле поиска
    };                  
  };

  useEffect(() => {
    dispatch(getOperators());
  }, []);
  useEffect(() => {
    dispatch(getSubOperators());
  }, []);

  useEffect(() => {
    onReset();
  }, [typeQuestion]);

  useEffect(() => {
    if (localStorage.getItem('dataPortal')) {
      //@ts-ignore
      const token = JSON.parse(localStorage.getItem('dataPortal')).token;
      const id = decodeToken(token);
      console.log(id)
      setUserId(id.id)
      dispatch(checkAuth({ ...id, token }));
    }
  }, []);

  
  return (
    <div className="filters-wrapper">
      <Typography variant="h6" component="h4" sx={{ margin: 1 }}>
        Фильтры:
      </Typography>
      <div className="filters">
        <div className="filters-block">
          <FormControl className="filters-block__item">
            <InputLabel variant="standard" htmlFor="themeFilter">
              По теме обращения
            </InputLabel>
            <NativeSelect
              inputProps={{
                name: 'themeFilter',
                id: 'themeFilter',
              }}
              onChange={(e) => handleChange('quesTheme', e.target.value)}
              value={quesTheme}
            >
              <option value="0">Все</option>
              <option value="akt_poverki">Акт замены, поверки ИПУ</option>
              <option value="statement">Выписка из лицевого счета</option>
              <option value="relationship">Договорные отношения</option>
              <option value="residents">Изменение количества проживающих</option>
              <option value="quality">Качество воды</option>
              <option value="service">Качество обслуживания потребителей</option>
              <option value="accrual">Начисления, перерасчёты</option>
              <option value="incorrectly_data">Некорректно внесены номер или дата поверки прибора учёта</option>
              <option value="cash_transfer">Перенос, возврат денежных средств</option>
              <option value="rebooking_ls">Переоформление лицевого счета</option>
              <option value="conversion_pay">Перерасчет размера платы за коммунальные услуги</option>
              <option value="connection">Подключение</option>
              <option value="appeal">Проблема с отправкой акта замены/поверки ИПУ</option>
              <option value="others">Прочее</option>  
              <option value="water">Работа систем водоснабжения</option>
              <option value="drains">Работа систем канализации</option>
              <option value="registration">Регистрация, авторизация, восстановление пароля</option>
              <option value="subsidy">Справка о начислениях и оплатах для оформления льгот, субсидий</option>
              <option value="spravka_debt">Справка об отсутствии задолженности</option>
              <option value="tariff">Тарифы, нормативы</option>
              <option value="devices">Установка, замена и поверка приборов учёта</option>
            </NativeSelect>
          </FormControl>
          
          {role === '2' ? (
            <FormControl className="filters-block__item">
              <InputLabel variant="standard" htmlFor="operatorsFilter">
                По исполнителю
              </InputLabel>
              <NativeSelect
                inputProps={{
                  name: 'operatorsFilter',
                  id: 'operatorsFilter',
                }}
                onChange={(e) => handleChange('operator_id', e.target.value)}
                value={operator_id || '0'}
              >
                <option value="0">Все</option>
                {operatorList?.map((el) => {
                  return (
                    <option value={el.ID} key={el.ID}>
                      {el.LAST_NAME}
                    </option>
                  );
                })}
              </NativeSelect>
            </FormControl>
          ) : null} 

          {userId === '95' ? (
            <FormControl className="filters-block__item">
              <InputLabel variant="standard" htmlFor="operatorsFilter">
                По исполнителю
              </InputLabel>
              <NativeSelect
                inputProps={{
                  name: 'operatorsFilter',
                  id: 'operatorsFilter',
                }}
                onChange={(e) => handleChange('operator_sub_id', e.target.value)}
                value={operator_sub_id || '0'}
              >
                <option value="0">Все</option>
                {operatorSubList?.map((el) => {
                  return (
                    <option value={el.ID} key={el.ID}>
                      {el.LAST_NAME}
                    </option>
                  );
                })}
              </NativeSelect>
            </FormControl>
          ) : null}

          <FormControl className="filters-block__item">
            <InputLabel variant="standard" htmlFor="priorityFilter">
              По статусу
            </InputLabel>
            <NativeSelect
              onChange={(e) => handleChange('questionStatus', e.target.value)}
              value={questionStatus}
            >
              <option value="0">Все</option>
              <option value="1">Новые</option>
              <option value="2">На рассмотрении</option>
              <option value="3">Отправлен запрос</option>
              <option value="5">Продлен срок</option>
              <option value="4">Выполненные</option>
            </NativeSelect>
          </FormControl>
          <FormControl className="filters-block__item">
            <InputLabel variant="standard" htmlFor="priorityFilter">
              По отправителю
            </InputLabel>
            <NativeSelect onChange={(e) => handleChange('source', e.target.value)} value={source}>
              <option value="0">Все</option>
              <option value="1">Сайт</option>
              <option value="2">Личный кабинет</option>
              <option value="3">Android</option>
              <option value="4">iOS</option>
            </NativeSelect>
          </FormControl>
        </div>

        <div className="filters-date filters-block">
          <LocalizationProvider dateAdapter={AdapterDayjs} locale={ru}>
            <div className="filters-date__items">
              <DatePicker
                className="filters-date__item"
                label="Начало периода"
                disableFuture
                value={firstDate || null}
                inputFormat="DD.MM.YYYY"
                views={['day', 'month', 'year']}
                mask="__.__.____"
                onChange={(newValue) =>
                  handleChange('firstDate', dayjs(newValue).format('YYYY.MM.DD'))
                }
                renderInput={(params) => <TextField {...params} variant="standard" id="fistDate" />}
              />
              <DatePicker
                className="filters-date__item"
                label="Конец периода"
                disableFuture
                value={lastDate}
                inputFormat="DD.MM.YYYY"
                onChange={(newValue) =>
                  handleChange('lastDate', dayjs(newValue).format('YYYY.MM.DD'))
                }
                renderInput={(params) => <TextField {...params} variant="standard" id="lastDate" />}
              />
              <FormControl className="filters-block__item">
                <InputLabel variant="standard" htmlFor="priorityFilter">
                  По сроку:
                </InputLabel>
                <NativeSelect onChange={(e) => handleChange('term', e.target.value)} value={term}>
                  <option value="0">Актуальные</option>
                  <option value="1">С истекающим сроком</option>
                  <option value="2">Просроченные</option>
                </NativeSelect>
              </FormControl>
              <FormControl className="filters-block__item">
                <InputLabel variant="standard" htmlFor="priorityFilter">
                  По приоритету
                </InputLabel>
                <NativeSelect
                  inputProps={{
                    name: 'priorityFilter',
                    id: 'priorityFilter',
                  }}
                  onChange={(e) => handleChange('priority', e.target.value)}
                  value={priority}
                >
                  <option value="0">Все</option>
                  <option value="1">Обычный</option>
                  <option value="3">Средний</option>
                  <option value="2">Высокий</option>
                </NativeSelect>
              </FormControl>
            </div>
          </LocalizationProvider>
        </div>

        <div className="filters-search filters-block">
          <FormControl className="filters-search__item">
            <InputLabel variant="standard" htmlFor="searchSelect">
              Поиск по:
            </InputLabel>
            <NativeSelect
              onChange={(e) => handleChange('typeSearch', e.target.value)}
              value={typeSearch}
              inputProps={{
                name: 'searchSelect',
                id: 'searchSelect',
              }}
            >
              <option value="">выбрать</option>
              <option value={'id'}>Номеру обращения</option>
              <option value={'fio'}>ФИО (лицевому счету)</option>
              <option value={'email'}>Email</option>
              <option value={'phone'}>Телефону</option>              
            </NativeSelect>
          </FormControl>
          <FormControl className="filters-search__item" sx={{ marginTop: '5px' }}>
            <Input
              inputRef={inpSearchRef}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    color="primary"
                    aria-label="Найти"
                    onClick={() => {
                      handleChange('searchQuery', inpSearchRef.current?.value || '');
                    }}
                  >
                    <SearchOutlinedIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <Button variant="contained" onClick={onReset}>
            Сбросить фильтры
          </Button>
        </div>
      </div>
    </div>
  );
};